import {Component, ViewChild} from '@angular/core';
import {DateTime, NavController, NavParams, Select} from 'ionic-angular';

import {CONFIG} from "../../../app/config";
import {ENUM, TAction, THotspotFlag, TImageModel, TPaymentFlag} from '../../../app/enum';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {LogadoService} from "../../../providers/logado-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {ModalActionPage} from '../modal-action/modal-action';
import {TFilterOpera} from '../../../pipes/filter-field/filter-field';
import {PaybookRepo} from '../../../repositories/payment-repo';
import {PaymentMenuPage} from '../payment-menu/payment-menu';

@Component({
    selector: 'page-parcela-menu',
    templateUrl: 'parcela-menu.html',
    providers: [HotspotService, PaybookRepo]
})
export class ParcelaMenuPage {

    THotspotFlag: any = THotspotFlag;
    TPaymentFlag: any = TPaymentFlag;
    TFilterOpera: any = TFilterOpera;
    TImageModel: any = TImageModel;

    enum: any = ENUM;
    config: any;
    logado: any;
    rootile: any;
    userset: any;

    etapa: number;

    rootspot: any;
    copyspot: any;

    freedsub: any;
    freedqtd: number;

    paybook: any;

    indexPL: number;
    _parcelamento: any = {qtde: 0, card: false, spot: false};

    @ViewChild(DateTime) iondate: DateTime;
    @ViewChild('hotspotFday') hotspotFday: Select;
    
    constructor(public navCtrl: NavController, public navParams: NavParams, public util: Util,
                public logadoService: LogadoService,
                public hotspotService: HotspotService,
                public paybookRepo: PaybookRepo) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');
        this.userset = this.navParams.get('userset'); //#NOUSE
        
        this.paybook = this.navParams.get('paybook');

        this.etapa = this.navParams.get('etapa');

        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');
        
        this.indexPL = this.navParams.get('indexPL');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Marketing', '/hotspot-mark');

        if (this.etapa == 2) this.parcelaInit();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        if (this.etapa == 0) return 'Fatura';
        if (this.etapa == 2) return (this.paybook.Parcelas.length > 1 ? '1º ' : '') + 'Vencimento';
        if (this.etapa == 3) return (this.indexPL + 1) + 'º parcela';

    }



    /** ********************************************* PARCELA OLHA ************************************************ **/
    /** ************************************************ setuper ************************************************** **/

    pendentPaga(parcela) {

        //Boleto, Cartao ou PIX
        this.util.open(parcela.ParcelaLeto, '_blank');

    }

    hotspotFree(hoje, that?) {

        this.copyspot.Hotspots[0].HotspotFlag = THotspotFlag.hfHotspotLimitado;
        this.copyspot.Hotspots[0].HotspotFlag = THotspotFlag.hfHotspotAberto;
        this.copyspot.Hotspots[0].HotspotFree = this.util.dateToStr(hoje);

        let json = this.copyspot.Hotspots[0];

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.hotspot(TAction.acFree, this.copyspot.Hotspots[0].HotspotID, this.rootile.Profile.ProfileID, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.util.populateObj(this.rootspot, this.copyspot);
                    if (that) that.dismiss();

                },
                erro => {

                    this.util.populateObj(this.copyspot, this.rootspot);
                    this.util.alertResult(erro);

                });

    }

    pendentFree() {

        let onOkey = (okey, that) => {

            this.hotspotFree(this.util.dateHoje(), that);

        };

        
        //EQUIPE
        if (this.rootile.Profile.ProfileTeam) {

            //Define dias para deixar aberto se estiver bloqueado "Freedom"
            if (this.freedsub) this.freedsub.unsubscribe();
            this.freedsub = this.hotspotFday.ionChange.subscribe(qtde => {
                let hoje = this.util.dateHoje();
                hoje.setDate(hoje.getDate() + parseInt(qtde));
                this.freedsub.unsubscribe();
                this.hotspotFree(hoje);
            });

            this.hotspotFday.open();
            return;

        }


        //CLIENTE
        let objectData = {modalinfo: this.config.modalinfo(this.util, 'emergency', onOkey)};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    devedorMail() {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.contrato(TAction.acMail, this.copyspot.Hotspots[0].Contrato.ContratoID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    setTimeout(() => this.util.toastSimply('Boleto enviada para ' + this.copyspot.Hotspots[0].HotspotMail), 500);
                    this.dismiss();
                },
                erro => this.util.alertResult(erro));

    }



    /** ************************************************ PARCELA ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    parcelaDebt(index, vencido?): number {

        return this.paybookRepo.parcelaDebt(this.paybook, index, vencido);

    }

    parcelaQtde() {

        let onParc = (parc) => {
            this.paybook.PaybookParc = parc;
            //this.consumoSave();
        };

        let debt = this.paybookRepo.consumoDebt(this.paybook, null);


        let buttons: Array<any> = [];
        buttons.push({text: 'Á vista', value: 0});
        for (let i = 2; i <= 12; i++) buttons.push({text: 'até ' + this.util.parcelar(debt, i), value: i});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = this.paybook.PaybookParc;
        this.util.pickerOpen(columns, onParc);

    }

    parcelaMent() {

        this._parcelamento.card = !this._parcelamento.card;
        this._parcelamento.spot = !this._parcelamento.spot;

    }

    parcelaHtml() {

        let parcelas = this.paybook.Parcelas;
        let entrada = (parcelas.length >= 2 && parcelas[0].ParcelaCash != parcelas[1].ParcelaCash);

        let html = '';
        if (entrada) {
            html += '<b>' + this._parcelamento.qtde + 'X • </b>';
            html += 'Entrada <b>' + this.util.dinheiro(parcelas[0].ParcelaCash, true, true) + '</b> + ';
        }
        html += '<b>' + (this._parcelamento.qtde - (entrada ? 1 : 0)) + '</b> ';
        html += this.util.plural(this._parcelamento.qtde, 'parcela') + ' de ';
        html += '<b>' + this.util.dinheiro(this.util.roundUp(this.paybookRepo.consumoDebt(this.paybook, null) / this._parcelamento.qtde), true, true) + '</b>';

        return html;
    }

    parcelaInit() {

        this._parcelamento.qtde = this.paybook.Parcelas.length;
        this._parcelamento.card = (this._parcelamento.qtde <= 1);
        this._parcelamento.spot = (this._parcelamento.qtde >= 2);

    }

    parcelaMini(): number {

        for (let i = this.paybook.Parcelas.length-1; i >= 0; i--) {
            let qtde = this.util.jsCount(this.paybook.Parcelas[i].Payjoins, ['Payments', 'PaymentID']);
            if (qtde > 0) return i+1;
        }

        return 0;

    }

    parcelaData() {

        let base = this.paybook.Parcelas[0].ParcelaData;
        let date = this.util.strToDate(base);

        this.paybook.Parcelas.forEach((PL, indexPL) => {
            if (indexPL > 0) {
                date.setMonth(date.getMonth()+1);
                let data = this.util.dateToStr(date);
                PL.ParcelaData = data;
            }
        });

    }

    parcelaCria() {

        let parcelas = this.paybook.Parcelas;

        //PARCELA-NEW
        if (parcelas.length == 0) {
            let parcela = {ParcelaID: 0, ParcelaCash: 0, ParcelaData: this.paybook.PaybookCria.split(' ')[0], ParcelaAgio: 0, Payjoins: []};
            this.paybook.Parcelas.push(parcela);
            this.parcelaCalc();
            return;
        }

        //PARCELA-ALL
        let base = parcelas[parcelas.length-1].ParcelaData;
        let bool = (this._parcelamento.qtde > parcelas.length);

        if (bool) {
            for (let i = 0; i <= parcelas.length-1; i++) {
                if (parcelas[i].Payjoins.length > 0) break;
            }

            let date = this.util.strToDate(base);

            for (let i = parcelas.length; i < this._parcelamento.qtde; i++) {
                date.setMonth(date.getMonth()+1);
                let data = this.util.dateToStr(date);

                let parcela = {ParcelaID: 0, ParcelaData: data, ParcelaAgio: 0, ParcelaCash: 0, Payjoins: []};
                this.paybook.Parcelas.push(parcela);
            }
        }

        if (!bool) {
            for (let i = parcelas.length-1; i >= this._parcelamento.qtde; i--) {
                if (parcelas[i].Payjoins.length > 0) break;
                parcelas.splice(i, 1);
            }
        }

        this.parcelaCalc();

    }

    parcelaCalc() {

        let qtde = this.paybook.Parcelas.length;
        let debt = this.paybookRepo.consumoDebt(this.paybook, null);

        /*
        this.paybook.Parcelas.forEach(PL => {
            let pago = this.util.jsSum(PL.Payjoins, ['Payments', 'PaymentCash'], 'PaymentFlag', this.paybookRepo.TPaymentJoin);
            debt = debt - pago;
            if (pago == 0 || pago < PL.ParcelaCash) qtde++;
        });
        */

        this.paybook.Parcelas.forEach(PL => {
            let pago = this.util.jsSum(PL.Payjoins, ['Payments', 'PaymentCash'], 'PaymentFlag', this.paybookRepo.TPaymentJoin);
            let novo = this.util.roundUp(debt / qtde);
            if (pago > novo) PL.ParcelaCash = pago;
            if (pago < novo) PL.ParcelaCash = novo;
            console.log(debt, novo, PL.ParcelaCash);
            debt = debt - PL.ParcelaCash;
        });

    }

    parcelaZero() {

        let onDate = () => {
            this.iondate.open();
        };

        let onLixo = () => {
            this.paybook.Parcelas.splice(0, 1);
            //this.parcelaSave();
        };


        /** OPEN **/
        let lixo = (this.paybook.Parcelas.length == 1);
        let title = (this.paybook.Parcelas.length == 1 ? '1º PARCELA' : 'VENCIMENTO');
        let buttons: Array<any> = [];
                  buttons.push({text: 'Vencimento', handler: () => onDate()});
                  buttons.push({text: 'Data Ágio',  handler: () => this.paybookRepo.parcelaAgio(this.paybook, 0)});
        if (lixo) buttons.push({text: 'Remover',    handler: () => onLixo(), role: 'destructive'});
        this.util.sheetOpen(buttons, title);

    }

    paymentLink(indexPL, indexPJ) {

        let object = {etapa: 4, userset: this.userset, paybook: this.paybook, indexPL: indexPL, indexPJ: indexPJ};
        this.util.modalopen(PaymentMenuPage, 'alto', false, object).subscribe();

    }



    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/parcela-menu/parcela-menu.ts